<template>
    <div class="w-100"
         v-bind:class="{'max-content-width':store.step!=='adContent','max-full-width':store.step==='adContent'}"
         v-if="store.step!=='intro' && store.step!=='thank-you' && store.step!=='terms' && store.step!=='privacy'">
        <ul class="steps list-inline d-flex justify-content-center no-margin">
            <li class="list-inline-item ">
                <a @click="store.changeStep('adType')" v-bind:class="adTypeClasses">1.&nbsp;<span class="d-none d-sm-inline">{{$t("Tuup")}}</span></a><span
                    class="menu-unvisited">&nbsp;&mdash;</span></li>
            <li class="list-inline-item">
                <a @click="store.changeStep('newspapers')" v-bind:class="newspaperClasses">2.&nbsp;<span
                        class="d-none d-sm-inline">{{$t("Valjaanded")}}</span></a><span class="menu-unvisited">&nbsp;&mdash;</span>
            </li>
            <li class="list-inline-item">
                <a @click="store.changeStep('client')" v-bind:class="clientClasses">3.&nbsp;<span class="d-none d-sm-inline">{{$t("Tellija")}}</span></a><span
                    class="menu-unvisited">&nbsp;&mdash;</span></li>
            <li class="list-inline-item">
                <a @click="store.changeStep('adContent')" v-bind:class="adContentClasses">4.&nbsp;<span
                        class="d-none d-sm-inline">{{$t("Sisu")}}</span></a><span
                    class="menu-unvisited">&nbsp;&mdash;</span></li>
            <li class="list-inline-item">
                <a @click="store.changeStep('dates')" v-bind:class="datesClasses">5.&nbsp;<span
                        class="d-none d-sm-inline">{{$t("Ilmumine")}}</span></a><span class="menu-unvisited">&nbsp;&mdash;</span>
            </li>
            <li class="list-inline-item">
                <a @click="store.changeStep('payment')" v-bind:class="paymentClasses">6.&nbsp;<span
                        class="d-none d-sm-inline">{{$t("Maksmine")}}</span></a>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../includes/store';

const props = defineProps({
    activeStep: String,
    steps: Array
});

const store = useMainStore();

const getClassObject = (step) => {
    let activeIndex = props.steps.indexOf(props.activeStep);
    let currentIndex = props.steps.indexOf(step);
    return {
        'menu-item': true,
        'menu-visited': currentIndex < activeIndex,
        'menu-active': currentIndex == activeIndex,
        'menu-unvisited': currentIndex > activeIndex
    };
}
        
const adTypeClasses = computed(() => getClassObject('adType'));
const newspaperClasses = computed(() => getClassObject('newspapers'));
const clientClasses = computed(() => getClassObject('client'));
const adContentClasses = computed(() => getClassObject('adContent'));
const datesClasses = computed(() => getClassObject('dates'));
const paymentClasses = computed(() => getClassObject('payment'));
</script>
